import React from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../../helpers/i18n';
import { selectYaServices } from '../../../../../../config/selectors';
import classes from './premium-button.css';

const PremiumButton = () => {
    const { yandex360 } = useSelector(selectYaServices);
    return (
        <Button
            elementType="a"
            className={classes.premiumButton}
            href={`${yandex360}/business/telemost?from=telemost_header`}
            size="md"
            view="brand"
            target="_blank"
        >
            {i18n('header', 'premium-button-text-v2')}
        </Button>
    );
};

export default PremiumButton;
